const en = {
  // Navbar
  favorites: 'Favorites',
  cart: 'Cart',
  search: 'search...',

  youMayAlsoLike: "You May Also Like",
  unitsInStock: "units in stock",
  selectSize: "Select Size",
  quantity: "Quantity",
  addtoCart: "Add to Cart",
  outOfStock: "Out of Stock",
  proceedtoCheckout: "Proceed to Checkout",
  subtotal: "Subtotal",
  delivery: "Delivery",
  "Delivery Cost": "Delivery Cost",
  total: "Total",
  shoppingCart: "Shopping Cart",
  cartIsEmpty: "Your Cart is Emty",
  customerName: "Customer Name",
  customerPhone: "Customer Phone",
  village: "Village",
  searchVillage: "Search for your village...",
  selectVillage: "Please select a village from the dropdown.",
  optional: "Optional",
  submitting: "Submitting...",
  enterCustomerName: "Enter customer name",
  enterCustomerPhone: "e.g. 70123456",
  clear: "Clear",
  size: "Size",
  color: 'Color',
  inStock: "in stock",
  available: "Available",
  searchForOtherProducts:"Search for Other Products",
  startTyping:"Start Typing to Search For Products",
  searchError: "An error occurred while searching. Please try again.",
  noResultsFound:"No Results Found for",
  searching: "Searching...",
  noMoreResults:"No More Results",
  searchHistory: "Search History",
  myOrders: "My Orders",
  noSavedOrders: "You have no saved orders.",
  orderPlaced: "Order placed successfully",
  orderNumber: "Order number",
  trackOrder: "Track order",
  trackPackage: "Track package",
  continueShopping: "Continue shopping",
  trackingUnavailable: "Tracking information is unavailable or has expired.",
  trackingExpired: "This tracking link has expired or is no longer valid.",
  orderNotFound: "Order not found.",
  tooManyRequests: "Too many requests. Please try again later.",
  trackingLoadFailed: "Unable to load this order.",
  loadingOrder: "Loading order...",
  orderStatus: "Order status",
  paymentStatus: "Payment status",
  shippingStatus: "Shipping status",
  orderDetails: "Order details",
  orderItems: "Order items",
  customer: "Customer",
  phone: "Phone",
  orderDate: "Order date",
  notes: "Notes",

  showAll: 'Show All',
  loadMore: 'Load More',
  goBack: 'Go back',
  failedToLoadProducts: 'Faild to Load Products',
  product: 'product',
  
  //Slide Menu
  menu: 'Menu',
  language: 'Language',
  followUs: 'Follow Us',
  information: 'Information',
  aboutUs: 'About Us',
  contactUs: 'Contact Us',
  privacyPolicy: 'Privacy Policy',
  selectedColor: 'Selected Color',
  selectColor : 'Select Color',

  //Admin dashboard
  categories: "Categories",
  orders: "Orders",
  coupons: "Coupons",
  shippingCompanies: "Shipping Companies",
  salesPoints: "Sales Points",
  merchantAccounts: "Merchant Accounts",
  brands: "Brands",
  eMarketing: "E-Marketing",
  branchesAndWarehouses: "Branches & Warehouses",
  cities: "Cities List",
  banners: "Banners",
  videos: "Videos",
  ads: "Advertisements",
  reviews: "Customer Reviews",
  storePolicies: "Store Policies",
  searchEngine: "Search Engine",
  searchEngineFriends: "Search Engine Optimization",
  settings: "System Settings",
  security: "Security & Protection",
  // Footer
  ourStore: 'Our Store',
  storeDescription: 'We provide you with the best products with the highest quality and best prices. Shop with us and enjoy a unique experience.',
  quickLinks: 'Quick Links',
  home: 'Home',
  products: 'Products',
  specialOffers: 'Special Offers',
  customerService: 'Customer Service',
  returnPolicy: 'Return Policy',
  shippingDelivery: 'Shipping & Delivery',
  termsConditions: 'Terms & Conditions',
  faq: 'FAQ',
  contactInfo: 'Contact Us',
  location: 'Palestine',
  workingHours: 'Saturday - Thursday',
  workingTime: '9:00 AM - 9:00 PM',
  copyright: '© 2025 All Rights Reserved - Our Store'
};
export default en;
